<template>
  <span>
    <span v-show="hasUnreadMessages" class="count_wrapper test-count_wrapper">
      <span aria-hidden="true" class="test-count" :title="ariaLabel">
        {{ count > 9 ? '9+' : count }}
      </span>
      <span class="sr_only">
        {{ ariaLabel }}
      </span>
    </span>
  </span>
</template>

<script>
import { EVENTS } from './unread_messages_events.js'

const NAV_DROPDOWN_COUNT_SELECTOR = '.js-dropdown_unread_count'
const NAV_DROPDOWN_NO_MESSAGES_CLASS = 'navigation__hamburger_menu_content__unread_count--no_messages'

export default {
  name: 'UnreadMessagesCounter',
  data: function () {
    return {
      count: Number(sessionStorage.getItem('unreadMessagesCount')) || 0,
      handlerRef: null
    }
  },
  computed: {
    hasUnreadMessages: function () {
      if (this.count) {
        return this.count > 0
      } else {
        return false
      }
    },
    ariaLabel: function () {
      return this.i18n.$ngettext('%{count} unread message', '%{count} unread messages', this.count, {
        count: this.count
      })
    }
  },
  beforeMount: function () {
    document.documentElement.addEventListener(EVENTS.UNREAD_MESSAGES_COUNT_UPDATED, this.onCountChange)
  },
  beforeUnmount: function () {
    document.documentElement.removeEventListener(EVENTS.UNREAD_MESSAGES_COUNT_UPDATED, this.onCountChange)
  },
  methods: {
    onCountChange({ detail: { count } }) {
      this.updateDropdownNav(count)
      this.count = count
      sessionStorage.setItem('unreadMessagesCount', count)
    },
    updateDropdownNav(count) {
      const elements = document.querySelectorAll(NAV_DROPDOWN_COUNT_SELECTOR)
      elements.forEach(e => {
        e.innerText = count
      })

      if (count === 0) {
        elements.forEach(e => e.classList.add(NAV_DROPDOWN_NO_MESSAGES_CLASS))
      } else {
        elements.forEach(e => e.classList.remove(NAV_DROPDOWN_NO_MESSAGES_CLASS))
      }
    }
  }
}
</script>
